import { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import BottomBarIcons from "./BottomBarIcons";
import Sidebar from "./Sidebar";
// import EnhancedTable from "./common/EnhancedTable";
import Approval from "./Approval";
import { useParams, useNavigate, generatePath } from "react-router-dom";
import { useEffect } from "react";
import http from "../api/server";
import Iframe from "react-iframe";
import {
  GET_PROPERTY_COMPLIANCE_SUMMARY,
  GET_PROPERTY_USER_MAPPING,
  UPDATE_PROPERTY_USER_MAPPING_STATUS,
  DOOR_INSPECTION_API,
  GET_PROPERTY_INFO_WITH_MASTER,
  GET_CLINET_ID_API,
  SEND_INSPECTOR_NOTIFICATION_APPROVAL,
  GET_ALL_INSPECTION_MASTER,
} from "../api/apiPath";
import useGetClientId from "../hooks/useGetClientId";
import { UserRoles, Statuses } from "../components/common/constant";
import { useSelector } from "react-redux";
import Toaster from "./common/Toaster";
import DataGridTable from "./common/DataGridTable";
import ConfirmationPopup from "./common/ConfirmationPopup";
import LoadingComponent from "./common/LoadingComponent";
import SidebarIcons from "./SidebarIcons";

const PropertyViewDetails = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [hideSidebar, setHideSidebar] = useState(true);
  const [complianceData, setComplianceData] = useState(null);
  const [filteredComplianceData, setfilteredComplianceData] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [showSubmitLoader, setShowSubmitLoader] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const { clientNameParam, propertyMasterId, inspectionRefnumber } =
    useParams();
  const [showModal, setShowModal] = useState(false);
  //const location = useLocation();
  //const { propertyInfo, userRole } = location.state || {};
  const [showApprovalButton, setShowApprovalButton] = useState(false);
  const [showSubmitForApprovalButton, setShowSubmitForApprovalButton] =
    useState(false);
  const { userObj } = useSelector((state) => state.user);
  const [showConfimBox, setShowConfimBox] = useState(false);
  const [propertyUserRoleMappingId, setPropertyUserRoleMappingId] =
    useState(null);
  const [inspectorInspectionStatus, setInspectorInspectionStatus] =
    useState(null);

  const clientObj = useGetClientId();
  const [propertyInfo, setPropertyInfo] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [noRecord, setNoRecord] = useState(false);
  const [isAnonymsProperty, setisAnonymsProperty] = useState(false);
  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const [filteredRows, setFilteredRows] = useState([]);
  const [inspectionPropertyData, setInpsectionPropertyData] = useState({});
  const [showNotifyButton, setshowNotifyButton] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [isnextInspectionDateNull, setIsNextInspectionDateNull] =
    useState(false);
  const [showDateModal, setShowDateModal] = useState(false);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  useEffect(() => {
    const fetchData = async () => {
      try {
        getPropertyUserMapping();
        const responseClient = await http.get(
          GET_CLINET_ID_API + "/" + userObj?.userId
        );
        setUserRole(responseClient?.data?.roleId);
        // const response = await http.get(
        //   `${GET_PROPERTY_COMPLIANCE_SUMMARY}?propertyMasterId=${propertyMasterId}` ///InspectionReferenceNumber=${inspectionRefnumber}`
        // );
        const response = await http.get(
          `${GET_PROPERTY_COMPLIANCE_SUMMARY}` +
            `?propertyMasterId=${encodeURIComponent(propertyMasterId)}` +
            `&InspectionReferenceNumber=${encodeURIComponent(
              inspectionRefnumber
            )}`
        );
        setComplianceData(response.data);
        setfilteredComplianceData(response.data);
        const tempApprovalpending =
          response?.data?.doorComplianceDetails.filter(
            (x) => x.status === Statuses.DOORUNDERREVIEW
          );
        if (tempApprovalpending.length > 0) {
          setshowNotifyButton(false);
        } else {
          const temprequestForChange =
            response?.data?.doorComplianceDetails.filter(
              (x) => x.status === Statuses.REQUESTFORCHANGE
            );
          temprequestForChange.length > 0
            ? setshowNotifyButton(true)
            : setshowNotifyButton(false);
        }
        const response1 = await http.get(
          GET_PROPERTY_INFO_WITH_MASTER +
            propertyMasterId +
            "?InspectionReferenceNumber=" +
            inspectionRefnumber
        );
        if (!response1.status) {
          throw new Error(`HTTP error! status: ${response1?.status}`);
        }
        setPropertyInfo(response1?.data?.inspectionPropertyInfo);

        if (
          response1?.data?.inspectionPropertyInfo?.nextInspectionDueDate ===
            null ||
          response1?.data?.inspectionPropertyInfo?.nextInspectionDueDate ===
            "0001-01-01T00:00:00"
        ) {
          setIsNextInspectionDateNull(true);
        } else {
          setIsNextInspectionDateNull(false);
        }

        setisAnonymsProperty(
          response1?.data?.inspectionPropertyInfo?.property?.isAnonymsProperty
        );
      } catch (error) {
        if (error?.status === 404) {
          setNoRecord(true);
        } else {
          throw new Error(`HTTP error! status: ${error}`);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [showApproveModal]);

  useEffect(() => {
    if (clientObj.clientId) {
      getInspectionMasterInfo();
    }
  }, [clientObj.clientId, clientObj.loading]);

  const getInspectionMasterInfo = async () => {
    const inspectionResponse = await http.get(
      GET_ALL_INSPECTION_MASTER + "?ClientId=" + clientObj?.clientId
    );
    if (inspectionResponse.status === 200) {
      const editData = inspectionResponse?.data?.filter(
        (x) => x.inspectionReferenceNumber == inspectionRefnumber
      );
      if (editData.length > 0) {
        setInpsectionPropertyData({
          ...inspectionPropertyData,
          status: editData[0].status,
          scheduledInspectionDate: editData[0].scheduledInspectionDate,
        });
      }
    }
  };
  const gotoDashBoard = () => {
    //const pathTemplate = "/client/:clientNameParam/scanNewDoor/:propertyMasterId/:inspectionRefnumber";
    const pathTemplate = "/client/:clientNameParam/dashboard/:propertyMasterId/:inspectionRefnumber";
    const params = {
      clientNameParam: clientNameParam,
      propertyMasterId: propertyMasterId,
      inspectionRefnumber: inspectionRefnumber,
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath);
  };

  const getPropertyUserMapping = async () => {
    const propInfoResp = await http.get(
      GET_PROPERTY_USER_MAPPING + propertyMasterId
    );
    if (!propInfoResp.status) {
      throw new Error(`HTTP error! status: ${propInfoResp?.status}`);
    }
    var status = propInfoResp?.data?.filter(
      (d) => d.userId == userObj.userId
    )[0]?.status;
    if (status) {
      setInspectorInspectionStatus(status);
    }
    var propertyUserRoleMappingId = propInfoResp?.data?.filter(
      (d) => d.userId == userObj.userId
    )[0]?.propertyUserRoleMappingId;
    setPropertyUserRoleMappingId(propertyUserRoleMappingId);
    if (status == Statuses.INPROGRESS) {
      setShowSubmitForApprovalButton(true);
    }

    // var totalInspector = propInfoResp?.data.length;
    var totalInspector =
      propInfoResp?.data?.filter((item) => item.roleId === 2).length ?? 0;

    var totalCompleted = propInfoResp?.data.filter(
      (x) => x.status == Statuses.COMPLETED && x.roleId === UserRoles.INSPECTOR
    ).length;
    if (totalInspector > 0) {
      if (totalInspector == totalCompleted) {
        setShowApprovalButton(true);
      } else {
        setShowApprovalButton(false);
      }
    }
  };

  const onSubmitForApproval = () => {
    setShowConfimBox(true);
  };
  const UpdateStatus = async () => {
    setShowSubmitLoader(true);
    const payload = {
      propertyUserRoleMappingId: propertyUserRoleMappingId,
      status: Statuses.COMPLETED,
      propertyMasterId: propertyMasterId,
      userId: userObj?.userId,
      email: userObj?.userEmail,
      inspectionReferenceNumber: inspectionRefnumber,
    };
    try {
      const response = await http.put(
        UPDATE_PROPERTY_USER_MAPPING_STATUS + propertyUserRoleMappingId,
        payload
      );
      response.status === 200
        ? setToastData({
            toastShow: true,
            toastType: "success",
            toastString: "Survey has been submitted for approval",
          })
        : setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: "Error in saving data, please try again",
          });
      if (!response.status) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      }
      setShowConfimBox(false);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } catch (error) {
      console.error("API Error:", error);
      // Display error message to user, if needed
    } finally {
      setShowSubmitLoader(false);
    }
  };

  const handleCancel = () => {
    setShowConfimBox(false);
  };

  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };

  const handleDownloadClick = async (propertyMasterId) => {
    setShowLoader(true);
    try {
      const response = await http.get(DOOR_INSPECTION_API, {
        params: {
          propertyId: propertyMasterId,
        },
        responseType: "blob",
      });

      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);

      setPdfUrl(fileURL);
      if (isMobile) {
        const link = document.createElement("a");
        link.href = fileURL;
        link.download = `${propertyMasterId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        setShowPdfModal(true); // 👉 show modal
      }
    } catch (error) {
      console.error("Download Failed", error);
    } finally {
      setShowLoader(false);
    }
  };

  const criticalIssues = filteredComplianceData?.criticalNonComplianceCount;
  const handleBack = () => {
    navigate(
      generatePath("/client/:clientNameParam/property-form", {
        clientNameParam,
      })
    );
  };

  const handleFilterRows = (rows) => {
    setFilteredRows(rows);

    setfilteredComplianceData({
      ...complianceData,
      totalDoors: rows.length,
      compliantCount: rows.filter(
        (row) => row.compliance === Statuses.COMPLIANT
      ).length,
      nonCompliantCount: rows.filter(
        (row) => row.compliance === Statuses.NONCOMPLIANT
      ).length,
      criticalNonComplianceCount: rows.filter(
        (row) => row.compliance === Statuses.CRITICAL
      ).length,
      complianceRate:
        (rows.filter((row) => row.compliance === Statuses.COMPLIANT).length /
          rows.length) *
          100 || 0,
    });

    console.log("Filtered Rows:", rows, filteredRows);
  };

  const closePopup = () => {
    setShowConfirmationPopup(false);
  };

  const notifyInspectorApi = async () => {
    setButtonLoading(true);
    try {
      const response = await http.post(SEND_INSPECTOR_NOTIFICATION_APPROVAL);
      if (!response.status) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      }
      response.status === 200
        ? setToastData({
            toastShow: true,
            toastType: "success",
            toastString: "Notification has been sent successfully",
          })
        : setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: "Error in sending notification, please try again",
          });
      setShowConfirmationPopup(false);
    } catch (error) {
      setShowConfirmationPopup(false);
       throw new Error(`HTTP error! status: ${error}`);
   
    } finally {
      setButtonLoading(false);
    }
  };
  const handleApprovalModalOpen = () => {
    setShowApproveModal(true);
  };

  return (
    <>
      <div>
        <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      </div>
      <Toaster
        show={toastData.toastShow}
        toastType={toastData.toastType}
        title={toastData.toastString}
        theme={"dark"}
        position="top-center"
        closeButton={() => {
          closeButton();
        }}
      />
      <div className="dashboard_body_main paddingClassForAddProperty">
        {/* {loading ? (
          <div className="spinloader"></div>
        ) : ( */}
        {hideSidebar ? (
          <Sidebar setHideSidebar={setHideSidebar} hideSidebar={hideSidebar} />
        ) : (
          <SidebarIcons />
        )}
        <div
          className="d-flex dashboard_body flex-column py-1 w-100"
          style={{
            position: "relative",
            minHeight: "100vh",
            // paddingLeft: "70px",
            paddingRight: "5px",
            transition: "0.5s",
          }}
        >
          <ConfirmationPopup
            show={showConfirmationPopup}
            headingText="Notify Inspectors"
            infoText="Please confirm if you want to send an email notification to all the Inspectors"
            cancelText="Cancel"
            submitText={buttonLoading ? "Please Wait" : "Send"}
            onCancel={() => {
              closePopup();
            }}
            onSubmit={() => notifyInspectorApi()}
          />
          <form className="row m-2">
            {criticalIssues >= 1 && (
              <div className="mb-3">
                <div className="d-flex align-items-center gap-2 information-icon w-auto float-end">
                  <i
                    className="bi bi-info-circle"
                    style={{ fontSize: "1.2rem" }}
                  ></i>
                  <small>
                    Some doors require attentions to maintain compliance
                  </small>
                  <span className="badge bg-warning text-dark rounded-circle">
                    {criticalIssues}
                  </span>
                </div>
              </div>
            )}
            {(userRole === UserRoles.APPROVER ||
              userRole === UserRoles.ADMIN) &&
              propertyInfo?.status == Statuses.COMPLETED &&
              isnextInspectionDateNull && (
                <div className="mb-3">
                  <div className="d-flex align-items-center gap-2 information-icon w-auto float-end">
                    <i
                      className="bi bi-info-circle"
                      style={{ fontSize: "1.2rem", marginTop: "-7px" }}
                    ></i>
                    <small>
                      The next inspection Due date for this property has not
                      been set.
                    </small>
                    <span
                      className="badge bg-warning text-dark rounded-button"
                      onClick={() => setShowDateModal(true)}
                    >
                      Set Inspection Date
                    </span>
                  </div>
                </div>
              )}
            <div className="mb-3">
              <div className=" col-12 col-sm-12 col-lg-12 ">
                <div className="card">
                  <div className="card-body">
                    {noRecord ? (
                      <div className="text-center py-4">No record found</div>
                    ) : (
                      <div className="d-flex flex-column flex-sm-row align-items-center ">
                        <div className="col-12 col-sm-4 col-lg-4 justify-content-sm-start ">
                          <h5 className="justifyStart">
                            {complianceData?.propertyName || "Property Name"}
                          </h5>
                          <p className="justifyStart mb-0">
                            <b>Location</b>:{" "}
                            {complianceData?.propertyLocation || ""}
                          </p>
                          <p className="justifyStart mb-0">
                            <b>Inspectors</b>:{" "}
                            {complianceData?.inspectors || ""}
                          </p>
                          <p className="justifyStart mb-0">
                            <b>Status</b>:{" "}
                            {complianceData?.propertyStatus ===
                            Statuses.INREVIEW
                              ? "In Progress"
                              : complianceData?.propertyStatus || ""}
                          </p>
                          <p className="justifyStart mb-0">
                            <b>Submitted Date</b>:{" "}
                            {complianceData?.submittedDate
                              ? new Date(
                                  complianceData.submittedDate
                                ).toLocaleDateString("en-US", {
                                  year: "numeric",
                                  month: "long",
                                  day: "numeric",
                                })
                              : "" || ""}
                          </p>
                          {propertyInfo?.status == Statuses.COMPLETED && (
                            <p className="justifyStart mb-0">
                              <b>Approval Date</b>:{" "}
                              {complianceData?.approvalDate
                                ? new Date(
                                    complianceData.approvalDate
                                  ).toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                  })
                                : "" || ""}
                            </p>
                          )}
                        </div>
                        <div
                          className="col-12 col-sm-8 col-lg-8 d-flex justify-content-end"
                          style={{
                            // flexDirection: "column",
                            // alignItems: "flex-end",
                            // justifyContent: "flex-end",
                            height: "-webkit-fill-available",
                          }}
                        >
                          {/* <div>
                          {showLoader ? (
                            <div className="loader"></div>
                          ) : (
                              propertyInfo?.status === Statuses.COMPLETED &&
                              (userRole === UserRoles.APPROVER || userRole === UserRoles.ADMIN) &&
                              <i
                                className="bi fa-solid fa-download fa-lg"
                                title="Download PDF"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  handleDownloadClick(propertyMasterId);
                                }}
                              ></i>)}
                        </div> */}
                          <div className="pv-actions w-100 mt-2 d-flex flex-row align-items-center justify-content-end gap-2">
                            {userRole === UserRoles.INSPECTOR &&
                              !isAnonymsProperty &&
                              (inspectionPropertyData?.status ===
                                Statuses.INPROGRESS ||
                                inspectionPropertyData?.status ===
                                  Statuses.SCHEDULED) &&
                              new Date(
                                inspectionPropertyData?.scheduledInspectionDate
                              ) <= new Date() &&
                              new Date(
                                inspectionPropertyData?.scheduledInspectionDate
                              ).getFullYear() >
                                new Date().getFullYear() - 1 && (
                                <button
                                  className="btn btn-secondary "
                                  onClick={() => gotoDashBoard()}
                                >
                                  New Door Survey
                                </button>
                              )}
                            {(userRole === UserRoles.APPROVER ||
                              userRole === UserRoles.ADMIN) &&
                              propertyInfo?.status ==
                                Statuses.SUBMITTEDFORAPPROVAL &&
                              showNotifyButton && (
                                <button
                                  className="btn btn-secondary"
                                  type="button"
                                  onClick={() => {
                                    setShowConfirmationPopup(true);
                                  }}
                                >
                                  {" "}
                                  Notify Inspectors{" "}
                                </button>
                              )}
                            {(userRole === UserRoles.APPROVER ||
                              userRole === UserRoles.ADMIN) &&
                              propertyInfo?.status ==
                                Statuses.SUBMITTEDFORAPPROVAL &&
                              showApprovalButton && (
                                <button
                                  className="btn btn-secondary"
                                  type="button"
                                  onClick={() => {
                                    setShowModal(true);
                                  }}
                                >
                                  {" "}
                                  Reject Survey{" "}
                                </button>
                              )}

                            <div className="pv-item">
                              {showLoader ? (
                                <div className="loader"></div>
                              ) : (
                                propertyInfo?.status !== Statuses.NOTSTARTED &&
                                propertyInfo?.status !== Statuses.INREVIEW &&
                                propertyInfo?.status !== null &&
                                propertyInfo?.status !== undefined && (
                                  <button
                                    type="button"
                                    className="btn btn-tertiary"
                                    title="Generate Report"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      handleDownloadClick(propertyMasterId);
                                    }}
                                  >
                                    Preview/Download
                                  </button>
                                )
                              )}
                            </div>
                            {userRole == UserRoles.INSPECTOR &&
                              (showSubmitForApprovalButton ||
                                propertyInfo?.status === Statuses.REJECTED) && (
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={onSubmitForApproval}
                                >
                                  {propertyInfo?.status === Statuses.REJECTED
                                    ? "Re-Submit for Approval"
                                    : "Submit for approval"}
                                </button>
                              )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-lg-12 mb-3">
              <div className="card">
                <div className="card-body">
                  <h5 className="justifyStart">Compliance Summary</h5>
                  {noRecord ? (
                    <div className="text-center py-4">No record found</div>
                  ) : (
                    <div>
                      <div className="row text-center d-flex justify-content-between mt-0">
                        <div className="col-6 col-sm-4 col-lg-2 mb-1">
                          <h3>{filteredComplianceData?.totalDoors}</h3>
                          <p className="fw-semibold">Total Doors</p>
                        </div>

                        <div className="col-6 col-sm-4 col-lg-2 mb-1">
                          <h3 className="text-success">
                            {filteredComplianceData?.compliantCount}
                          </h3>
                          <p className="fw-semibold">Compliant</p>
                        </div>
                        <div className="col-6 col-sm-4 col-lg-2 mb-1">
                          <h3 className="text-danger">
                            {filteredComplianceData?.nonCompliantCount}
                          </h3>
                          <p className="fw-semibold">Non-Compliant</p>
                        </div>
                        <div className="col-6 col-sm-4 col-lg-2 mb-1">
                          <h3>
                            {filteredComplianceData?.criticalNonComplianceCount}
                          </h3>
                          <p className="fw-semibold">Critical Issues</p>
                        </div>

                        {/* <div className="col-4 col-sm-2">
                      <h3>1</h3>
                      <p className="fw-semibold">Require Attention</p>
                    </div> */}
                      </div>
                      <div className="mt-1">
                        <small className="mb-2 d-block">
                          Overall Compliance Rate :{" "}
                          {isNaN(filteredComplianceData?.complianceRate)
                            ? filteredComplianceData?.complianceRate
                            : Math.round(
                                Number(filteredComplianceData?.complianceRate)
                              )}
                          %
                        </small>
                        <div className="progress completed">
                          <div
                            className="progress-bar"
                            role="progressbar"
                            style={{
                              width: `${filteredComplianceData?.complianceRate}%`,
                            }}
                            aria-valuenow="40"
                            aria-valuemin="0"
                            aria-valuemax="100"
                          ></div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-lg-12 mb-3 ">
              <div className="card">
                <div className="card-body">
                  <h5 className="justifyStart">
                    Door Surveys
                    {(userRole === UserRoles.APPROVER ||
                      userRole === UserRoles.ADMIN) &&
                      propertyInfo?.status == Statuses.SUBMITTEDFORAPPROVAL && (
                        <i
                          className="bi bi-info-circle"
                          style={{
                            fontSize: "0.9rem",
                            marginTop: "-7px",
                            marginLeft: "5px",
                          }}
                          title="To Approve the complete survey, please make sure all doors are selected and click on 'Approve All Doors' button. 
                      To approve the surveys individually, please click on the view icon below"
                        ></i>
                      )}
                  </h5>

                  <div className="table-responsive">
                    {/* {complianceData?.doorComplianceDetails?.length > 0 && (
                      <EnhancedTable
                        tableData={complianceData.doorComplianceDetails}
                      />
                    )} */}
                    {noRecord ? (
                      <div className="text-center py-4">No record found</div>
                    ) : (
                      complianceData?.doorComplianceDetails?.length > 0 && (
                        <DataGridTable
                          tableData={complianceData.doorComplianceDetails.sort(
                            (a, b) =>
                              new Date(b.doorInspectionDate) -
                              new Date(a.doorInspectionDate)
                          )}
                          userRole={userRole}
                          propertyInfo={propertyInfo}
                          inspectorInspectionStatus={inspectorInspectionStatus}
                          onFilteredRowsChange={(rows) => {
                            handleFilterRows(rows);
                          }}
                          onApproveAllButton={() => handleApprovalModalOpen()}
                          pageSize={10}
                        />
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body action_btns d-flex justify-content-end gap-3 pb-3 px-3 flex-wrap flex-sm-nowrap">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  handleBack();
                }}
              >
                Back
              </button>
            </div>
          </form>
        </div>
        {/* // )} */}
        <Footer />
        <div className="bottom-bar-spacing"></div>
        <BottomBarIcons />
      </div>
      <LoadingComponent loading={loading} />
      {showModal && (
        <Approval
          data={propertyInfo}
          isApprove={false}
          isDueDate={false}
          onClose={() => {
            setShowModal(false);
          }}
          inspectionRefnumber={inspectionRefnumber}
        />
      )}
      {showDateModal && (
        <Approval
          data={propertyInfo}
          isApprove={false}
          isDueDate={true}
          onClose={() => {
            setShowDateModal(false);
          }}
          inspectionRefnumber={inspectionRefnumber}
        />
      )}
      {showApproveModal && (
        <Approval
          data={propertyInfo}
          isApprove={true}
          isDueDate={false}
          onClose={() => {
            setShowApproveModal(false);
          }}
          inspectionRefnumber={inspectionRefnumber}
        />
      )}
      {showConfimBox && (
        <div className="modal-overlay">
          <div
            className="approval-modal-content"
            style={{ height: "fit-content" }}
          >
            <span className="close" onClick={handleCancel}>
              &times;
            </span>
            <h6 className="modal-header">Confirmation</h6> {/* Modal Header */}
            <div className="modal-body" style={{ marginTop: "-10px" }}>
              <span>
                Once you submit for approval, you will no longer be able to
                modify or complete any pending door inspections. Please make
                sure all door surveys are fully completed before proceeding.
              </span>
              <div className="row">
                <div>
                  <div
                    className="card-body action_btns d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap "
                    style={{ marginTop: "5px" }}
                  >
                    {showSubmitLoader ? (
                      <div
                        className="loader mt-2"
                        style={{ marginRight: "20px" }}
                      ></div>
                    ) : (
                      <>
                        <button
                          type="button"
                          className="btn btn-tertiary"
                          onClick={() => {
                            handleCancel();
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => {
                            UpdateStatus();
                          }}
                        >
                          Submit
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showPdfModal && pdfUrl && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            zIndex: 1050,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "90%",
              maxHeight: "80vh",
              backgroundColor: "#fff",
              borderRadius: "8px",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                padding: "10px 15px",
                borderBottom: "1px solid #ddd",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h5 className="modal-title mb-0">PDF Preview</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  setShowPdfModal(false);
                  setPdfUrl(null);
                }}
              ></button>
            </div>
            <div style={{ height: "90vh", padding: 0 }}>
              <Iframe
                src={pdfUrl}
                width="100%"
                height="100%"
                title="PDF Preview"
                style={{
                  border: "none",
                  display: "block",
                  width: "100%",
                  height: "100%",
                }}
                frameBorder="0"
              ></Iframe>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default PropertyViewDetails;
